import { RadioValue } from "../components/RadioGroup/RadioGroup";

export const referenceTemperatureMethod: RadioValue[] = [
  { label: "Mid point", value: "mid" },
  { label: "Dew point", value: "dew" },
];
